export default __webpack_public_path__ + "static/media/Clap.90707c55.wav";